/** Matches trekker `zIndex="max"` and embed widget overlay stacking. */
export const SLIDEOUT_DIALOG_Z_INDEX = 2147483647;
